import type { HttpMethod } from '@/api/client';

/**
 * Map HTTP method → Tailwind classes for method badges.
 *
 * Neo-brutalism: solid pastel background + near-black text (high contrast,
 * no opacity tints) so badge pops against cream canvas. Border + offset
 * shadow handled by .method-badge base class in globals.css.
 */
export function methodBadgeClass(method: HttpMethod | string): string {
  const m = method.toLowerCase();
  switch (m) {
    case 'get':
      return 'bg-method-get text-fg';
    case 'post':
      return 'bg-method-post text-fg';
    case 'put':
      return 'bg-method-put text-fg';
    case 'delete':
      return 'bg-method-delete text-fg';
    case 'patch':
      return 'bg-method-patch text-fg';
    default:
      return 'bg-overlay text-fg-tertiary';
  }
}
